import { Alert, Box } from "@backstage/ui";

import styles from "./PermissionDenied.module.css";

/** Props for the PermissionDenied component. */
export interface PermissionDeniedProps {
    message?: string;
}

/** Displays a standardized access denied message. Drop-in errorPage for RequirePermission. */
export const PermissionDenied = ({
    message = "You do not have permission to access this content.",
}: PermissionDeniedProps) => (
    <Box className={styles.container}>
        <Alert
            status="danger"
            icon
            title="Access Denied"
            description={message}
        />
    </Box>
);
